import { render, staticRenderFns } from "./NavigationEntryTemplate.vue?vue&type=template&id=5bec6884&scoped=true&"
import script from "./NavigationEntryTemplate.vue?vue&type=script&lang=ts&"
export * from "./NavigationEntryTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationEntryTemplate.vue?vue&type=style&index=0&id=5bec6884&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bec6884",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VIcon,VListGroup,VListItem,VListItemContent,VListItemIcon,VListItemTitle})
